import { render, staticRenderFns } from "./igrosLogo.vue?vue&type=template&id=2f601259&scoped=true&"
import script from "./igrosLogo.vue?vue&type=script&lang=js&"
export * from "./igrosLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f601259",
  null
  
)

export default component.exports